import { render } from "./WorkspacePicker.vue?vue&type=template&id=bab418fc&scoped=true"
import script from "./WorkspacePicker.vue?vue&type=script&lang=js"
export * from "./WorkspacePicker.vue?vue&type=script&lang=js"

import "./WorkspacePicker.vue?vue&type=style&index=0&id=bab418fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bab418fc"]])

export default __exports__